module.exports = __webpack_public_path__ + "img/logo1.2a1e7035.png";